"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VCCProvisioned = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.VCCProvisioned = typebox_1.Type.Object({
    vendorName: typebox_1.Type.String(),
    cardLast4: typebox_1.Type.String(),
});
//# sourceMappingURL=vcc-provisioned.js.map